/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  
  /* @ngdoc object
   * @name vcutils.sv
   * @description
   *
   */
  angular
    .module('vcutils.sv', [
      'ui.router',
      'vcutils.rlog',
      'vcutils.sprhelp',
      'vcutils.zipcode'
    ]);
}());
